import DOMPurify from 'dompurify';

export default {
  mounted(el, binding) {
    // Add an event listener to sanitize before saving or displaying
    el.addEventListener('blur', (event) => {
      const sanitizedValue = DOMPurify.sanitize(event.target.value);
      el.value = sanitizedValue;

      // Emit the sanitized value back to Vue's v-model
      if (binding.instance) {
        binding.instance.$emit('input', sanitizedValue);
      }
    });
  },
};
